import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/shared/models/api-response.interface';
import { HttpService } from './http.service';
import { AddThirdPartyProductRequest } from '../../../shared/models/add-third-party-product.interface';

@Injectable({
  providedIn: 'root',
})
export class MemberApiService {
  constructor(private apiService: HttpService) {}

  createMember(payload: any): Observable<ApiResponse> {
    return this.apiService.postReq(`/member/`, payload);
  }

  createDealer(payload: any): Observable<ApiResponse> {
    return this.apiService.postReq(`/member/Dealer`, payload);
  }

  updateMember(id: number, payload: any): Observable<ApiResponse> {
    return this.apiService.putReq(`/member/${id}`, payload);
  }

  getApprovalEmails(memberId: number): Observable<ApiResponse> {
    return this.apiService.getReq(`/member/${memberId}/approval-emails`);
  }

  updateApprovalEmails(memberId: number, emails: string[]): Observable<ApiResponse> {
    return this.apiService.putReq(`/member/${memberId}/approval-emails`, { approval_emails: emails });
  }

  addProduct(payload: AddThirdPartyProductRequest) {
    return this.apiService.postReq(`/third-party-product/add`, payload);
  }

  removeProduct(third_party_id: number, product_ids: number[]) {
    return this.apiService.deleteReq(`/third-party-product/remove`, {
      body: { third_party_id, product_ids: product_ids },
    });
  }

  assignAgentToDealers(
    agent_id: number,
    dealer_ids: number[]
  ): Observable<ApiResponse> {
    return this.apiService.putReq(`/assign-agent-to-dealers`, {
      agent_id,
      dealer_ids,
    });
  }

  unassignAgentToDealers(dealer_ids: number[]): Observable<ApiResponse> {
    return this.apiService.putReq(`/un-assign-agent-to-dealers`, {
      dealer_ids,
    });
  }

  // ─── Third-Party Attachments ──────────────────────────────────

  getAttachedThirdParties(agentId: number, params: any = {}): Observable<ApiResponse> {
    return this.apiService.getReq(`/member/${agentId}/third-parties`, { params });
  }

  attachThirdParties(agentId: number, thirdPartyIds: number[]): Observable<ApiResponse> {
    return this.apiService.postReq(`/member/${agentId}/third-parties`, { third_party_ids: thirdPartyIds });
  }

  detachThirdParties(agentId: number, thirdPartyIds: number[]): Observable<ApiResponse> {
    return this.apiService.deleteReq(`/member/${agentId}/third-parties`, {
      body: { third_party_ids: thirdPartyIds },
    });
  }

  getThirdPartyUsers(
    agencyId: number,
    thirdPartyId: number,
    params: any = {}
  ): Observable<ApiResponse> {
    return this.apiService.getReq(
      `/member/${agencyId}/third-parties/${thirdPartyId}/users`,
      { params }
    );
  }

  attachSubUserToThirdParty(subUserId: number, thirdPartyId: number): Observable<ApiResponse> {
    return this.apiService.postReq(`/member/${subUserId}/third-parties`, {
      third_party_ids: [thirdPartyId],
    });
  }

  detachSubUserFromThirdParty(subUserId: number, thirdPartyId: number): Observable<ApiResponse> {
    return this.apiService.deleteReq(`/member/${subUserId}/third-parties`, {
      body: { third_party_ids: [thirdPartyId] },
    });
  }

  getThirdPartyCommissions(agentId: number, params: any = {}): Observable<ApiResponse> {
    return this.apiService.getReq(`/member/${agentId}/third-party-commissions`, { params });
  }

  getProductAdmins(search: string = ''): Observable<ApiResponse> {
    return this.apiService.getReq(`/third-parties/product-admins`, { params: { search } });
  }
}
